import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import {
  searchMetriportDestinations,
  searchReferralDestinations,
} from '@lotushealth/lotushealth_js_sdk/endpoints';

import { createLotusRequestConfig } from '@/shared/api/lotus';

import type { MetriportRecipient, NppesRecipient } from '../model/referralRecipient';

export type RecipientSearchResult<T> =
  | { type: 'success'; recipients: T[] }
  | { type: 'unavailable'; details: string };

export interface RecipientSearchParams {
  query: string;
  /** A ZIP, a prefix such as `911*`, or empty to search anywhere. */
  postalCode: string;
  state: string;
}

export async function searchNppesRecipients(
  { query, postalCode, state }: RecipientSearchParams,
  signal?: AbortSignal
): Promise<RecipientSearchResult<NppesRecipient>> {
  const config = await createLotusRequestConfig({ signal });
  const response = await searchReferralDestinations(
    {
      query,
      postal_code: postalCode || null,
      state: state || null,
    },
    config
  );
  const reply = lotusHealthZod.searchReferralDestinationsResponse.parse(response.data);
  if (reply.type === 'unavailable') {
    return reply;
  }
  return {
    type: 'success',
    recipients: reply.destinations.map((destination) => ({
      channel: 'nppes',
      destination,
    })),
  };
}

export async function searchMetriportRecipients(
  { query, postalCode, state }: RecipientSearchParams,
  signal?: AbortSignal
): Promise<RecipientSearchResult<MetriportRecipient>> {
  const config = await createLotusRequestConfig({ signal });
  const response = await searchMetriportDestinations(
    { query, postal_code: postalCode || null, state: state || null },
    config
  );
  const reply = lotusHealthZod.searchMetriportDestinationsResponse.parse(response.data);
  if (reply.type === 'unavailable') {
    return reply;
  }
  return {
    type: 'success',
    recipients: reply.destinations.map((destination) => ({
      channel: 'metriport',
      destination,
    })),
  };
}
